export default __webpack_public_path__ + "static/media/element_spec_45.ec1e1c91.webp";